import Vue from "vue/dist/vue.esm";

import QuotationNew from "../modules/quotation/new/App.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
Vue.component("vue-phone-number-input", VuePhoneNumberInput);

import initSentry from "../modules/common/sentry";

const components = {
  QuotationNew,
};

document.addEventListener("DOMContentLoaded", () => {
  new Vue({
    el: "#quotation-new-container",
    components,
  }).$mount();
});

initSentry(Vue);
